import React, { useEffect, useState } from "react";
import AnsibleList from "../components/Ansible/AnsibleList";
import AnsibleDetail from "../components/Ansible/AnsibleDetail";
import AnsibleForm from "../components/Ansible/AnsibleForm";
import axios from "axios";

const AnsiblePage = () => {
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const fetchJobs = async () => {
    try {
      const token = localStorage.getItem("access");
      const res = await axios.get(`${process.env.REACT_APP_API_ANSIBLE}/api/ansible/tasks/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setJobs(res.data);
    } catch (err) {
      console.error("❌ 작업 목록 조회 실패", err);
      alert("작업 목록을 불러오는 데 실패했습니다.");
    }
  };

  const handleCreate = async (form) => {
    try {
      const token = localStorage.getItem("access");
      await axios.post(`${process.env.REACT_APP_API_ANSIBLE}/api/ansible/tasks/`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert("✅ 작업이 생성되었습니다.");
      setShowForm(false);
      fetchJobs();
    } catch (err) {
      console.error("❌ 작업 생성 실패", err);
      alert("작업 생성에 실패했습니다.");
    }
  };

  const handleRun = async (id) => {
    try {
      const token = localStorage.getItem("access");
      await axios.post(`${process.env.REACT_APP_API_ANSIBLE}/api/ansible/tasks/${id}/run/`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert("✅ 작업 실행 요청 완료");
      fetchJobs();
    } catch (err) {
      console.error("❌ 작업 실행 실패", err);
      alert("작업 실행에 실패했습니다.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("정말로 삭제하시겠습니까?")) return;
    try {
      const token = localStorage.getItem("access");
      await axios.delete(`${process.env.REACT_APP_API_ANSIBLE}/api/ansible/tasks/${id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert("✅ 삭제 완료");
      fetchJobs();
      setSelectedJob(null);
    } catch (err) {
      console.error("❌ 삭제 실패", err);
      alert("삭제 실패");
    }
  };

  const handleEdit = async (id, updatedData) => {
    try {
      const token = localStorage.getItem("access");
      await axios.put(
        `${process.env.REACT_APP_API_ANSIBLE}/api/ansible/tasks/${id}/`,
        updatedData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("✅ 작업 수정 완료");
      fetchJobs();
      setSelectedJob(null);
    } catch (err) {
      console.error("❌ 작업 수정 실패", err);
      alert("작업 수정에 실패했습니다.");
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 py-10 px-6">
      <div className="max-w-3xl mx-auto">
        {/* 상단 버튼 */}
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold text-[#3B82F6]">Ansible 작업 목록</h1>
          <button
            onClick={() => setShowForm(!showForm)}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            {showForm ? "닫기" : "➕ 작업 생성"}
          </button>
        </div>

        {/* 생성 폼 */}
        {showForm && <AnsibleForm onCreate={handleCreate} onCancel={() => setShowForm(false)} />}

        {/* 작업 리스트 */}
        <AnsibleList jobs={jobs} onItemClick={setSelectedJob} />
      </div>

      {/* 상세창 Drawer */}
      <AnsibleDetail
        task={selectedJob}
        onClose={() => setSelectedJob(null)}
        onRun={handleRun}
        onDelete={handleDelete}
        onEdit={handleEdit}
      />
    </div>
  );
};

export default AnsiblePage;
